export default __webpack_public_path__ + "static/media/FionaAbney-McPeek.1e6511a6.jpeg";